import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#FF8E53',
            main: '#da5b22',
            dark: '#994118',
            contrastText: '#FFF',
        },
        secondary: {
            light: '#569FE3',
            main: '#396A97',
            dark: '#213D57',
            contrastText: '#FFF',
        },
        error: {
            light: '#ED6D6D',
            main: '#A11A1A',
            dark: '#540D0D',
            contrastText: '#FFF',
        },
        warning: {
            light: '#F7D09B',
            main: '#E9A84D',
            dark: '#755527',
            contrastText: '#FFF',
        },
        info: {
            light: '#EBEBEB',
            main: '#ABABAB',
            dark: '#6B6B6B',
            contrastText: '#FFF',
        },
        success:{
            light: '#B5FFCA',
            main: '#179364',
            dark: '#0D5439',
            contrastText: '#FFF',
        },
    },
    typography: {
        h1: {
            fontWeight: "700",
            fontSize: "3rem",
            lineHeight: "1.15",
            letterSpacing: "-0.01562em",
        },
        h2: {
            fontWeight: "700",
            fontSize: "2.5rem",
            lineHeight: "1.15",
            letterSpacing: "-0.01562em",
        },
        h3: {
            fontWeight: "700",
            fontSize: "2.125rem",
            lineHeight: "1.15",
            letterSpacing: "-0.01562em",
        },
        h4: {
            fontWeight: "500",
            fontSize: "2.125rem",
            lineHeight: " ",
            letterSpacing: "0.00735em",
        },
        h5: {
            fontWeight: "500",
            fontSize: "1.5rem",
            lineHeight: " ",
            letterSpacing: "0.00735em",
        },
        h6: {
            fontWeight: "500",
            fontSize: "1.25rem",
            lineHeight: " ",
            letterSpacing: "0.00735em",
        },
        body1: {
            fontWeight: "300",
            fontSize: "1rem",
            lineHeight: " ",
            letterSpacing: "0em",
        },
        body2: {
            fontWeight: "300",
            fontSize: "0.875rem",
            lineHeight: " ",
            letterSpacing: "0em",
        },
    },
});

export default theme;
